import { api } from '@services';

import FieldConfiguration, {
  FieldConfigurationLocationOptions,
  IFieldConfiguration,
  IFieldConfigurationApiModel,
} from '@models/FieldConfiguration.model';

const indexFieldConfiguration = async (
  location: FieldConfigurationLocationOptions,
): Promise<IFieldConfiguration[]> => {
  const { data: fieldsConfiguration } = await api.get<
    IFieldConfigurationApiModel[]
  >(`/fieldsConfiguration/${location}`);
  if (fieldsConfiguration.length > 0)
    return FieldConfiguration.arrayFromApiModel(
      fieldsConfiguration,
      location,
    ).sort((a, b) => a.order - b.order);
  return FieldConfiguration.defaultArray(location);
};

export { indexFieldConfiguration };
